import { render, staticRenderFns } from "./DownloadDocumentsDataModal.vue?vue&type=template&id=04a82087&"
import script from "./DownloadDocumentsDataModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentsDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports